import { ActivatedRoute, NavigationExtras, Params } from '@angular/router';

export class UrlHelper {
    /**
     * The URL requested, before initial routing.
     */
    static readonly initialUrl = location.href;
}

export const appendQueryParams = (queryParams: Params, route: ActivatedRoute): NavigationExtras => {
    return {
        relativeTo: route,
        queryParams,
        queryParamsHandling: 'merge',
        preserveFragment: true,
    };
};

export const buildEntityIdNavExtras = (entityId: string | number, route: ActivatedRoute): NavigationExtras => {
    return appendQueryParams({ entityId }, route);
};

export const removeEntityIdParam = (route: ActivatedRoute): NavigationExtras => {
    return buildEntityIdNavExtras(null, route);
};
